export default __webpack_public_path__ + "static/media/light_bulp.93111dfd.png";